import React, { useCallback, useContext, useEffect, useState, useMemo, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import SliderContainer from "./components/SliderContainer";
import Banner from "./components/Banner";
import CategoryGrid from "./components/CategoryGrid";
import axios from "axios";
import { sharedGet, sharedPost } from "../utils/sharedGet";
import { AuthContext, base_url } from "../context/Authcontext";
import '../../src/assets/AdminCss/card.css';
import ScrollableContent from "./components/ScrollableContent";
import Cricket from "./Cricket";
import toast from "react-hot-toast";
import pLimit from 'p-limit';
import LoginReg from "./LoginReg";
import TopBar from "./components/TopNavbar";
import CarouselF from "./components/CarouselF";
import Racing from "./components/Racing";
import MarqueeBottom from "./components/MarqueeBottom";
import RbFooter from "./components/RbFooter";
import UnavailablePanel from "./components/UnavailablePanel";
import PromoStrip from "./components/PromoStrip";
import { useLiveCounts } from "../utils/liveCounts";
import EventCard from "./components/EventCard";
import { useTheme } from "../context/ThemeContext";
import { useLocation } from 'react-router-dom';
import Carousel from "./components/Carousel";
import { Spinner } from "react-bootstrap";
import WhatsAppButton from "./components/WhatsAppButton";


const formatDate = (dateString) => {

  if (!dateString) return null;

  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // Only date (YYYY-MM-DD)
};


// const compareWithToday = (openDate) => {
//   const now = new Date();

//   // Get today's date
//   const today = formatDate(now);

//   // Get tomorrow's date by adding 1 day to the current date
//   const tomorrow = formatDate(new Date(now.getTime() + 24 * 60 * 60 * 1000)); // 24 hours in milliseconds

//   // Convert openDate string to Date object
//   const eventDateObj = new Date(openDate);

//   const eventDateFormatted = formatDate(eventDateObj);

//   return eventDateFormatted === today || eventDateFormatted === tomorrow;
// };


const compareWithToday = (openDate) => {
  const now = new Date();

  // Get today's date
  const today = formatDate(now);

  // Get tomorrow's date by adding 1 day to the current date
  const tomorrow = formatDate(new Date(now.getTime() + 24 * 60 * 60 * 1000)); // 24 hours in milliseconds

  // Convert openDate string to Date object
  const eventDateObj = new Date(openDate);

  const eventDateFormatted = formatDate(eventDateObj);

  return eventDateFormatted === today;
};

const getMinutesSinceMidnight = (date) => {
  return date.getUTCHours() * 60 + date.getUTCMinutes(); // Ensures UTC time handling
};






// Casino category tiles. The list index on each is the same one
// CasinoGames.js filters by, so a tile lands on that category already
// selected. Artwork is the existing local imagery -- swap the img paths
// when real category art arrives.
// 800x500 (16:10, the tile's shape); ?v= busts browser caches when the
// artwork is replaced under the same name. The original art was 101x101 icons
// stretched to ~300px tiles, which is why the row looked blurred; those
// icons stay in place for the other pages that still use them.
const CASINO_TILES = [
  { label: "Live Casino", img: "/assets/images/casino/live-casino.webp?v=2", list: 7 },
  { label: "Blackjack", img: "/assets/images/casino/blackjack.webp?v=2", list: 15 },
  { label: "Baccarat", img: "/assets/images/casino/baccarat.webp?v=2", list: 10 },
  { label: "Roulette", img: "/assets/images/casino/roulette.webp?v=2", list: 9 },
  { label: "Crash Games", img: "/assets/images/casino/crash-games.webp?v=2", list: 11 },
  { label: "Poker", img: "/assets/images/casino/poker.webp?v=2", list: 14 },
  { label: "Slots", img: "/assets/images/casino/slots.webp?v=2", list: 16 },
  { label: "Teen Patti", img: "/assets/images/casino/teen-patti.webp?v=2", list: 4 },
];

// Quick access replaces the three promotional images that used to sit
// under the hero. Racing is deliberately absent: there is no racing route
// in this app, and a tile that goes nowhere is worse than one fewer tile.
/* Quick access.
 *
 * Real sport artwork rather than Font Awesome glyphs: cricket.webp,
 * football.webp and the rest are 100x100 stickers that were already in
 * the project, sitting behind a d-none block nobody rendered. A drawn
 * cricket ball reads instantly in a way fa-trophy never will, and the
 * same file doubles as the card's background watermark so it costs one
 * download, not two.
 *
 * `tint` is the sport's own colour, used at low opacity in one corner so
 * the six cards are told apart at a glance instead of being six
 * identical navy rectangles.
 */
const QUICK_ACCESS = [
  {
    title: "Cricket",
    sub: "Match & fancy markets",
    img: "/assets/images/cricket.webp",
    tint: "rgba(39, 194, 129, 0.30)",
    countKey: "cricket",
    path: "/cricketreal",
  },
  {
    title: "Football",
    sub: "Leagues worldwide",
    img: "/assets/images/football.webp",
    tint: "rgba(21, 155, 211, 0.30)",
    countKey: "football",
    path: "/footballreal",
  },
  {
    title: "Tennis",
    sub: "ATP, WTA & more",
    img: "/assets/images/tennis.webp",
    tint: "rgba(245, 185, 0, 0.26)",
    countKey: "tennis",
    path: "/tennisreal",
  },
  {
    title: "Casino",
    sub: "Slots & table games",
    img: "/assets/images/casino_lobby.webp",
    tint: "rgba(155, 89, 232, 0.30)",
    path: "/casinoGames",
    state: { list: 0 },
  },
  {
    title: "Live Casino",
    sub: "Real dealers, real time",
    img: "/assets/images/live_casino.webp",
    tint: "rgba(224, 82, 82, 0.28)",
    path: "/casinoGames",
    state: { list: 7 },
  },
  {
    title: "Aviator",
    sub: "Crash game",
    img: "/assets/images/aviator-icon.svg",
    tint: "rgba(224, 82, 82, 0.30)",
    // Opens the Crash Games section (Aviator and the other crash games) --
    // the same place as Crash Games in the menu -- rather than launching one
    // provider game directly.
    path: "/casinoGames",
    state: { list: 11 },
  },
];

const Inplay = ({
  data,
  onCount,
  timeFilter,
  setTimeFilter,
  teamQuery,
  setTeamQuery,
  // The All sports page lists every match for the chosen sport; the home
  // page shows a few per sport and links there for the rest.
  showAll = false,
}) => {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const [cricket, setCricket] = useState([]);
  const [expandedSports, setExpandedSports] = useState({});
  const [avail, setAvail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBet, setSelectedBet] = useState(0);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(0);
  const [money, setMoney] = useState(0);
  const [pr, setPr] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [side, setSide] = useState("");
  const [active, setActive] = useState(false);
  const [selectedMatch, setSelectedMatch] = useState("");
  const [selectionid, setSelectionid] = useState();
  const [runner, setRunner] = useState();
  const [competition, setCompetition] = useState();
  const [eventid, setEventid] = useState();
  const [eventname, setEventname] = useState();
  const [profit, setProfit] = useState(0);
  const [time, setTime] = useState();

  const [rawMatches, setRawMatches] = useState([]);
  const [marketList, setMarketList] = useState([]);

  const sortMatches = (matches) => {
    return [...matches].sort((a, b) => {

      const aLive = a?.inplay || a?.event?.inPlay || a?.event?.status === "LIVE";
      const bLive = b?.inplay || b?.event?.inPlay || b?.event?.status === "LIVE";

      // 1️⃣ Live matches first
      if (aLive && !bLive) return -1;
      if (!aLive && bLive) return 1;

      // 2️⃣ Then by increasing start time
      const timeA = new Date(a?.event?.openDate).getTime();
      const timeB = new Date(b?.event?.openDate).getTime();

      return timeA - timeB;
    });
  };
  //  const location= useLocation();

  // const [list, setList]= useState(location?.state?.list || 0);


  //  const tabStyle = (index) => ({
  //   padding: "6px 12px",
  //   alignItems: "center",
  //   cursor: "pointer",
  //   flexShrink: 0,
  //   fontWeight: 600,
  //   background: list === index ? "#41a1ef" : "transparent",
  //   color: "#fff",
  //   borderRadius: "2px",
  //   width:'auto'
  // });

  // ✅ STEP 1A: matchData - setRawMatches instead of setCricket
  const matchData = async () => {
    setLoading(true);
    try {
      const response = await sharedGet(base_url + "/api/webapi/matchapi", {
        headers: { "Content-Type": "application/json" },
      });
      // console.log("API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1B: footballData - setRawMatches instead of setCricket
  const footballData = async () => {
    setLoading(true);
    try {
      const response = await sharedGet(base_url + "/api/webapi/footballapi", {
        headers: { "Content-Type": "application/json" },
      });
      // console.log("Football API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      // console.log("Filtered Football Matches:", allData);
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("Football API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ STEP 1C: tennisData - setRawMatches instead of setCricket
  const tennisData = async () => {
    setLoading(true);
    try {
      const response = await sharedGet(base_url + "/api/webapi/tennisapi", {
        headers: { "Content-Type": "application/json" },
      });
      // console.log("Tennis API Response:", response?.data);
      const data = response?.data?.result?.data || [];
      const allOpenDates = data.map(dta => dta?.event?.openDate);
      const allData = [];
      data.forEach((dta) => {
        if (compareWithToday(dta?.event?.openDate, allOpenDates)) {
          allData.push(dta);
        }
      });
      // console.log("Filtered Tennis Matches:", allData);
      setRawMatches(allData); // ✅ changed
    } catch (error) {
      console.error("Tennis API Error:", error);
    } finally {
      // setLoading(false);
    }
  };

  // ✅ STEP 2: rawMatches changes → getMarkets (no more loop because we don't set rawMatches here)
  useEffect(() => {
    const getMarkets = async () => {
      setLoading(true)
      if (rawMatches.length === 0) return;

      try {

        const eventIds = rawMatches.map(item => item?.event?.id);

        const response = await sharedPost(
          `${base_url}/game/kheloyaar/getMarkets`,
          { eventIds }
        );

        const markets = response.data.data || [];

        // 🔥 SORT MATCHES
        const sortedMarkets = sortMatches(markets);

        setMarketList(sortedMarkets);
        setCricket(sortedMarkets);

      } catch (err) {
        console.error("Markets Error:", err);
      } finally {
        // setLoading(false);
      }

    };

    getMarkets();

  }, [rawMatches]);

  // ✅ STEP 3: marketList changes → fetchOdds (no more loop because we don't set marketList here)
  useEffect(() => {
    const fetchOdds = async () => {
      setLoading(true)
      if (!marketList || marketList.length === 0) return;
      try {
        const marketIds = marketList.map(item => item.marketId).filter(Boolean);
        const chunks = [];
        for (let i = 0; i < marketIds.length; i += 10) {
          chunks.push(marketIds.slice(i, i + 10));
        }
        const requests = chunks.map(chunk =>
          axios.post(`${base_url}/api/webapi/market/wholeMarket`, {
            marketIds: chunk
          })
        );

        const responses = await Promise.all(requests);

        let allOdds = [];

        responses.forEach(response => {
          const oddsData =
            typeof response.data === "string"
              ? JSON.parse(response.data)
              : response.data;

          const markets = oddsData?.data?.data || [];
          allOdds = [...allOdds, ...markets];
        });
        // console.log("Fetched Odds Data:", allOdds);
        setAvail(allOdds);
      } catch (error) {
        console.error("Odds Fetch Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOdds();
  }, [marketList]); // ✅ only marketList — no loop


  const [formData, setFormData] = useState({
    competiton: "",
    eventname: "",
    eventid: 0,
    marketId: "",
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: "",
    status: 0,
  });

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };

  const handleBetClick = async (item, index, marketid) => {
    // console.log(item);
    // console.log(index);
    // console.log(marketid);
    try {
      const match = cricket.find((cric) => cric.marketId === marketid);
      const runners = match.runners;
      setEventid(match?.event.id);
      setEventname(match?.event.name);
      setCompetition(match?.competition.name);
      const time = formatDate(match?.event.openDate);
      setTime(time);
      // console.log(match);

      if (index < 2) {
        setSelectionid(runners[0].selectionId);
        setRunner(runners[0].runnerName);
      } else {
        setSelectionid(runners[1].selectionId);
        setRunner(runners[1].runnerName);
      }

      if (item?.type === "Back") {
        // console.log('back called');
        setbackActive(1);
        setlayActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      } else if (item?.type === "Lay") {
        // console.log('lay called');
        setlayActive(1);
        setbackActive(0);
        setSide(item.type);
        setSelectedBet(index);
        setSelectedPrice(item.price);
        setSelectedMatch(marketid);
      }
    } catch (err) {
      console.log(err);
    }
  };
  // console.log(selectionid, runner);

  function isTenMinutesRemaining(isoString) {
    const targetTime = new Date(isoString).getTime(); // Convert given time
    const currentTime = new Date().getTime(); // Get current time

    // Calculate the difference in milliseconds
    const timeDifference = targetTime - currentTime;

    // Convert milliseconds to minutes
    const minutesRemaining = timeDifference / (1000 * 60);

    return minutesRemaining > 10;
  }

  const handleSubmit = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }

    // if(isTenMinutesRemaining(time)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (money < 100) {
      toast.error("Bet cant be placed less than min value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }

    // console.log('form',formData);

    try {
      const response = await axios.post(
        base_url + "/api/webapi/sportsData",
        formData,
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log('formmatch',response);

      if (response?.data.success) {
        toast.success(response?.data.message);
      } else {
        toast.error(response?.data.message);
      }
      // window.location.reload();
      setbackActive(0);
      setlayActive(0);
    } catch (err) {
      console.log(err);
      toast.error("Failed to place bet");
    }
  };

  const handleClick = (item) => {
    // console.log(item);

    sessionStorage.clear();
    sessionStorage.setItem("marketId", item.marketId);
    sessionStorage.setItem("competetionid", item.competition.id);
    sessionStorage.setItem("eventid", item.event.id);
    sessionStorage.setItem("time", item?.event.openDate);
    sessionStorage.setItem("competitionname", item?.competition.name);
    sessionStorage.setItem("eventname", item?.event.name);

    if (item.eventType.name === "Cricket") {
      navigate("/cricketBet");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);

      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);
      // console.log(item.runners, item.runners.length);
      if (item?.runners.length === 3) {
        sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
        sessionStorage.setItem("runner3", item.runners[2].runnerName);
      }
    } else if (item.eventType.name === "Soccer") {
      navigate("/footBAllBet");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);
      sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);

      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);
      sessionStorage.setItem("runner3", item.runners[2].runnerName);
    } else if (item.eventType.name === "Tennis") {
      navigate("/tennis");
      sessionStorage.setItem("selectionid1", item?.runners[0].selectionId);
      sessionStorage.setItem("selectionid2", item?.runners[1].selectionId);

      sessionStorage.setItem("runner1", item.runners[0].runnerName);
      sessionStorage.setItem("runner2", item.runners[1].runnerName);

      if (item?.runners.length === 3) {
        sessionStorage.setItem("selectionid3", item?.runners[2].selectionId);
        sessionStorage.setItem("runner3", item.runners[2].runnerName);
      }
    }
  };

  // 1. Fetch matchData only on mount or when `data` changes
  useEffect(() => {
    const fetchData = async () => {
      if (data === 0) {
        await matchData();
      } else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      }
    };

    fetchData();
  }, [data]); // Only when 'data' changes

  // // 2. When cricket is updated, then call odds API
  // useEffect(() => {
  //   const oddsData = async () => {
  //     if (cricket.length === 0) return;

  //     try {
  //       const marketid = cricket.map((item) => item.marketId);

  //       const response = await axios.post(
  //         `${base_url}/api/webapi/market/wholeMarket`,
  //         marketid,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           timeout: 10000,
  //         }
  //       );

  //       const result = JSON.parse(response.data); // Remove JSON.parse if response is already JSON
  //       setAvail(result);
  //     } catch (err) {
  //       console.error("Error fetching odds data:", err);
  //     }
  //   };

  //   oddsData();
  // }, [cricket]);

  // 3. Calculate profit separately
  useEffect(() => {
    if (!isNaN(selectedPrice) && !isNaN(money)) {
      const proft =
        parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
      setProfit(proft.toFixed(1));
    }
  }, [selectedPrice, money]); // Only update when those change

  // console.log('vall',cricket);

  formData.competiton = competition;
  formData.eventid = eventid;
  formData.eventname = eventname;
  formData.marketId = selectedMatch;
  formData.selectionId = selectionid;
  formData.runnername = runner;
  formData.betPrice = selectedPrice;
  formData.betAmount = money;
  formData.side = side;
  formData.profit = profit;
  // console.log(avail);
  // console.log(avail);

  // The home page rendered every market it received -- 200 rows on a normal
  // day. Show a few per sport and let the visitor ask for the rest.
  const MATCHES_PER_SPORT = 3;
  const SPORT_LABELS = { Soccer: "Football" };

  const matchesWithOdds = cricket.filter((item) => {
    const market = avail.find((m) => m.marketId === item.marketId);
    return (
      market &&
      market.runners?.some(
        (runner) =>
          runner?.ex?.availableToBack?.length > 0 ||
          runner?.ex?.availableToLay?.length > 0
      )
    );
  });

  const countsBySport = matchesWithOdds.reduce((acc, item) => {
    const sport = item?.eventType?.name || "Other";
    acc[sport] = (acc[sport] || 0) + 1;
    return acc;
  }, {});

  // Report upward so the tab strip can show a live count for the sport on
  // screen. onCount is memoised by the parent, so this settles immediately.
  useEffect(() => {
    if (onCount) onCount(data, matchesWithOdds.length);
  }, [data, matchesWithOdds.length, onCount]);

  // Time and team filters. The tab counts above stay on the unfiltered
  // totals on purpose -- a tab that changed its own number as you filtered
  // would be reporting two different things at once.
  const now = Date.now();
  const endOfToday = (() => {
    const d = new Date();
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  })();
  const endOfTomorrow = endOfToday + 24 * 60 * 60 * 1000;

  const query = (teamQuery || "").trim().toLowerCase();

  const filteredMatches = matchesWithOdds.filter((item) => {
    if (query) {
      const haystack = (item?.runners || [])
        .map((r) => r?.runnerName || "")
        .concat([item?.competition?.name || ""])
        .join(" ")
        .toLowerCase();
      if (haystack.indexOf(query) === -1) return false;
    }
    const start = new Date(item?.event?.openDate).getTime();
    if (timeFilter === "live") return start <= now;
    if (timeFilter === "today") return start <= endOfToday;
    if (timeFilter === "tomorrow") return start > endOfToday && start <= endOfTomorrow;
    return true;
  });

  const seenBySport = {};
  const visibleMatches = filteredMatches.filter((item) => {
    const sport = item?.eventType?.name || "Other";
    seenBySport[sport] = (seenBySport[sport] || 0) + 1;
    return showAll || expandedSports[sport] || seenBySport[sport] <= MATCHES_PER_SPORT;
  });

  return (
    <>
      {<LoginReg active={active} setactive={setActive} />}
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >

            <div _ngcontent-jrx-c94="" className="">
              {/* Filters. Useful the moment a sport has more than a
                  screenful, which cricket already does. */}
              <div className="rb-filters">
                {[
                  { key: "all", label: "All" },
                  { key: "live", label: "Live" },
                  { key: "today", label: "Today" },
                  { key: "tomorrow", label: "Tomorrow" },
                ].map((f) => (
                  <button
                    type="button"
                    key={f.key}
                    className={timeFilter === f.key ? "rb-chip rb-chip--active" : "rb-chip"}
                    onClick={() => setTimeFilter && setTimeFilter(f.key)}
                  >
                    {f.label}
                  </button>
                ))}
                <label className="rb-search">
                  <i className="fa fa-search" aria-hidden="true" />
                  <input
                    type="search"
                    value={teamQuery || ""}
                    placeholder="Search teams"
                    aria-label="Search teams"
                    onChange={(e) => setTeamQuery && setTeamQuery(e.target.value)}
                  />
                </label>
              </div>

              <div _ngcontent-jrx-c94="" className="sports-wrapper rb-events">

                {loading ? (
                  /* Skeletons rather than a spinner on a blank page: the
                     list keeps its shape while the odds arrive. */
                  <>
                    {Array.from({ length: 3 }).map((_, i) => (
                      <div
                        key={"skel" + i}
                        className="rb-skeleton rb-skeleton--event"
                        aria-hidden="true"
                      />
                    ))}
                    <span className="rb-visually-hidden" role="status">
                      Loading matches
                    </span>
                  </>
                ) : visibleMatches.length > 0 ? (
                  visibleMatches
                    .map((item, index) => {
                      const market = avail.find(m => m.marketId === item.marketId);

                      const runner1 = market?.runners?.[0];
                      const runner2 = market?.runners?.[1];

                      const r1Back = runner1?.ex?.availableToBack?.[0]?.price;
                      const r1Lay = runner1?.ex?.availableToLay?.[0]?.price;

                      const r2Back = runner2?.ex?.availableToBack?.[0]?.price;
                      const r2Lay = runner2?.ex?.availableToLay?.[0]?.price;


                      const marketData = market?.runners || [];

                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          id={item?.competition?.id}
                          className="rb-event"
                          style={{ position: "relative" }}
                        >
                          <EventCard
                            item={item}
                            marketData={marketData}
                            onOpen={handleClick}
                          />
                          {/* betting back div */}
                          {backActive === 1 &&
                            side === "Back" &&
                            (
                              <div
                                style={{
                                  backgroundColor: "#052e36",
                                  padding: "15px",
                                  color: "white",
                                  borderRadius: "5px",
                                  width: "100%",
                                }}
                                className="homebet"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#0A6E8A",
                                      color: "white",
                                      padding: "8px 20px",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setbackActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    BACK
                                  </button>
                                  <div
                                    style={{
                                      color: "#4ADE80",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Profit:{" "}
                                    {(money * (selectedPrice - 1)).toFixed(1)}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "8px",
                                      }}
                                      id="matchAtAnyRate"
                                    />
                                    <label htmlFor="matchAtAnyRate">
                                      Match At Any Rate
                                    </label>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <div className="w-25" style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Odds
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handlelayChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={selectedPrice}
                                        onChange={(e) =>
                                          setSelectedPrice(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handlelayChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  <div className="w-25" style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Stake
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handleChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={money}
                                        onChange={(e) =>
                                          setMoney(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "#064150",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handleChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(100)}
                                  >
                                    + 100
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(200)}
                                  >
                                    + 200
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(500)}
                                  >
                                    + 500
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(1000)}
                                  >
                                    + 1k
                                  </button>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(5000)}
                                  >
                                    + 5k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(10000)}
                                  >
                                    + 10k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(25000)}
                                  >
                                    + 25k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#064150",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(50000)}
                                  >
                                    + 50k
                                  </button>
                                </div>

                                {/* <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#166534",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Min
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#1e3a8a",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Max
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#7e22ce",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Edit Stake
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#991b1b",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Clear
                                  </button>
                                </div> */}

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    gap: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#ef4444",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setbackActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#22c55e",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => handleSubmit()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            )}

                          {/* betting lay div */}
                          {layActive === 1 &&
                            side === "Lay" &&
                            (
                              <div
                                style={{
                                  backgroundColor: "rgb(247 150 255 / 40%)",
                                  padding: "15px",
                                  color: "white",
                                  borderRadius: "5px",
                                  width: "100%",
                                }}
                                className="homebet"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 20px",
                                      border: "none",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setbackActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Lay
                                  </button>
                                  <div
                                    style={{
                                      color: "#4ADE80",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Profit:{" "}
                                    {(money * (selectedPrice - 1)).toFixed(1)}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        marginRight: "8px",
                                      }}
                                      id="matchAtAnyRate"
                                    />
                                    <label htmlFor="matchAtAnyRate">
                                      Match At Any Rate
                                    </label>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Odds
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handlelayChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={selectedPrice}
                                        onChange={(e) =>
                                          setSelectedPrice(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handlelayChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  <div style={{ flex: 1 }}>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      Stake
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "40px",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "4px 0 0 4px",
                                        }}
                                        onClick={() => handleChange(0)}
                                      >
                                        −
                                      </button>
                                      <input
                                        type="text"
                                        value={money}
                                        onChange={(e) =>
                                          setMoney(e.target.value)
                                        }
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          border: "none",
                                          flex: 1,
                                          textAlign: "center",
                                          fontSize: "18px",
                                          width: "10px",
                                        }}
                                      />
                                      <button
                                        style={{
                                          backgroundColor: "rgb(247 150 255 / 60%)",
                                          color: "white",
                                          width: "40px",
                                          border: "none",
                                          fontSize: "20px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "0 4px 4px 0",
                                        }}
                                        onClick={() => handleChange(1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(100)}
                                  >
                                    + 100
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(200)}
                                  >
                                    + 200
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(500)}
                                  >
                                    + 500
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(1000)}
                                  >
                                    + 1k
                                  </button>
                                </div>

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(5000)}
                                  >
                                    + 5k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(10000)}
                                  >
                                    + 10k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(25000)}
                                  >
                                    + 25k
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "rgb(247 150 255 / 60%)",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={() => setMoney(50000)}
                                  >
                                    + 50k
                                  </button>
                                </div>

                                {/* <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(4, 1fr)",
                                    gap: "8px",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#166534",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Min
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#1e3a8a",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Max
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#7e22ce",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Edit Stake
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#991b1b",
                                      color: "white",
                                      padding: "8px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Clear
                                  </button>
                                </div> */}

                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    gap: "8px",
                                  }}
                                >
                                  <button
                                    style={{
                                      backgroundColor: "#ef4444",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      setlayActive(0);
                                      setMoney(0);
                                      setPr(0);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#22c55e",
                                      color: "white",
                                      padding: "12px 0",
                                      border: "none",
                                      borderRadius: "3px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => handleSubmit()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            )}
                        </div>
                      );
                    })
                ) : (
                  <div className="rb-empty">
                    <span className="rb-empty__icon" aria-hidden="true">
                      <i className="fa fa-calendar-xmark" />
                    </span>
                    <span className="rb-empty__title">No matches to show</span>
                    <span className="rb-empty__body">
                      {teamQuery || timeFilter !== "all"
                        ? "Nothing matches that filter right now. Try All times, or clear the search."
                        : "There are no priced markets for this sport at the moment. Check back shortly."}
                    </span>
                    {(teamQuery || timeFilter !== "all") && (
                      <button
                        type="button"
                        className="rb-btn rb-btn--secondary rb-btn--sm"
                        onClick={() => {
                          if (setTeamQuery) setTeamQuery("");
                          if (setTimeFilter) setTimeFilter("all");
                        }}
                      >
                        Clear filters
                      </button>
                    )}
                  </div>
                )}

                {/* Home page: the rest of a sport's matches live on the All
                    sports page, opened on that sport's tab. */}
                {!loading && !showAll && (
                  <div className="d-flex flex-wrap gap-2 justify-content-center py-3">
                    {Object.keys(countsBySport)
                      .filter((sport) => countsBySport[sport] > MATCHES_PER_SPORT)
                      .map((sport) => {
                        const label = SPORT_LABELS[sport] || sport;
                        const tab = { Cricket: 0, Soccer: 1, Football: 1, Tennis: 2 }[sport];
                        return (
                          <button
                            key={sport}
                            type="button"
                            onClick={() =>
                              navigate("/sportall", tab === undefined ? undefined : { state: { sport: tab } })
                            }
                            className="rb-btn rb-btn--secondary rb-btn--sm"
                          >
                            {`Show all ${countsBySport[sport]} ${label} matches`}{" "}
                            <span aria-hidden="true">{"\u2192"}</span>
                          </button>
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

/* =====================================================================
   All sports  (/sportall)
   =====================================================================
   The home page's Sports section -- Cricket / Football / Tennis tabs,
   filters, event cards -- without the three-per-sport limit. Replaces the
   old CricketAll list. Opens on the tab passed as location.state.sport
   (the home page's "Show all N ... matches" buttons pass it). */
export const AllSports = () => {
  const location = useLocation();
  const SPORTS = ["Cricket", "Football", "Tennis"];
  const requested =
    location.state && Number.isInteger(location.state.sport) ? location.state.sport : 0;
  const [activeSportIdx, setActiveSportIdx] = useState(requested);
  const [sportCounts, setSportCounts] = useState({});
  const [timeFilter, setTimeFilter] = useState("all");
  const [teamQuery, setTeamQuery] = useState("");
  const [isSidebar, setSidebar] = useState(false);
  const isSmallScreen = typeof window !== "undefined" && window.innerWidth <= 768;
  const handleSportCount = useCallback((idx, n) => {
    setSportCounts((prev) => (prev[idx] === n ? prev : { ...prev, [idx]: n }));
  }, []);

  // Arriving again with a different sport (e.g. from the home page while
  // already here) switches the tab.
  useEffect(() => {
    setActiveSportIdx(requested);
  }, [requested, location.key]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <app-root>
      <app-landing-page-new className="ng-star-inserted">
        <div className="head-container">
          <Header isSidebar={isSidebar} setSidebar={setSidebar} />
          <div className="body-container">
            <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} isDesktop={!isSmallScreen} />
            <div className="rightbar" style={{ width: "100%" }}>
              <app-upcoming className="ng-star-inserted">
                <div className="upcoming-container">
                  <section className="rb-section">
                    <div className="rb-section__head">
                      <h1 className="rb-section__title">All sports</h1>
                    </div>

                    <div className="rb-sportbar">
                      <div className="sport-tabs" role="tablist" aria-label="Sports">
                        {SPORTS.map((sport, idx) => {
                          const isActive = idx === activeSportIdx;
                          const count = sportCounts[idx];
                          return (
                            <button
                              key={sport}
                              type="button"
                              role="tab"
                              aria-selected={isActive}
                              onClick={() => setActiveSportIdx(idx)}
                              className={isActive ? "sport-tab sport-tab--active" : "sport-tab"}
                            >
                              <span className="sport-tab__label">{sport}</span>
                              {count !== undefined && (
                                <span className="sport-tab__count">{count}</span>
                              )}
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <Inplay
                      data={activeSportIdx}
                      onCount={handleSportCount}
                      timeFilter={timeFilter}
                      setTimeFilter={setTimeFilter}
                      teamQuery={teamQuery}
                      setTeamQuery={setTeamQuery}
                      showAll
                    />
                  </section>
                </div>
              </app-upcoming>
              <RbFooter />
              <MarqueeBottom onMenuClick={() => setSidebar(true)} />
            </div>
            <WhatsAppButton />
          </div>
        </div>
      </app-landing-page-new>
    </app-root>
  );
};

export const FrontPage = () => {
  // Published by the header, which already polls the three match feeds --
  // so the quick-access cards can show a live count for nothing.
  const liveCounts = useLiveCounts();
  const SPORTS = ["Cricket", "Football", "Tennis"];
  const [activeSportIdx, setActiveSportIdx] = useState(0);
  const [sportCounts, setSportCounts] = useState({});
  const [timeFilter, setTimeFilter] = useState("all");
  const [teamQuery, setTeamQuery] = useState("");
  // Stable identity so Inplay's reporting effect does not re-fire forever.
  const handleSportCount = useCallback((idx, n) => {
    setSportCounts((prev) => (prev[idx] === n ? prev : { ...prev, [idx]: n }));
  }, []);

  const { themeColors } = useTheme();
  const [isSidebar, setSidebar] = useState(false);
  const [isInplay, setInplay] = useState(true);
  const [isTomorrow, setTomorrow] = useState(false);
  const [isUpcoming, setUpcoming] = useState(false);
  const [isActive, setActiveLink] = useState(0);
  const [jiliGames, setJiliGames] = useState([]);
  const [active, setactive] = useState(false);
  const [token, setToken] = useState();
  const [casino, setCasino] = useState([]);
  const [ent, setEnt] = useState([]);
  const [endorphina, setEndorphina] = useState([]);
  // const [latest, setLatest]= useState([]);
  const [evolution, setEvolution] = useState([]);
  const [games, setGames] = useState([]);
  // The game feed is a server-sent stream that can finish, error, or simply
  // never deliver. Without this the grid would show skeletons for ever,
  // which reads as a hung page rather than "no games".
  const [gamesLoading, setGamesLoading] = useState(true);
  // Bumped by the retry button; the game stream effect keys off it.
  const [gamesAttempt, setGamesAttempt] = useState(0);
  const [searchText, setSearchText] = useState('');
  const { isAuthenticated } = useContext(AuthContext);
  const [regactive, setregactive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [list, setList] = useState(location?.state?.list || 0);

  const handlePlay = (id) => {
    setInplay(false);
    setTomorrow(false);
    setUpcoming(false);

    if (id === "inplay") {
      setInplay(true);

    } else if (id === "tomorrow") {
      setTomorrow(true);

    } else {
      setUpcoming(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // Start closed and let the visitor open it. Forcing it open above
    // 991px put a fixed panel over the page content.
    setSidebar(false);
  }, []);

  // The game stream is its own effect so the retry button can re-run just
  // this, rather than re-running a mount effect that also scrolls the page
  // back to the top.
  useEffect(() => {
    let gamesTimeout;

    const casinogames = async () => {
      try {
        const eventSource = new EventSource(base_url + '/api/valid/token', {
          withCredentials: true
        });

        let receivedGames = [];

        // Provider groupings
        const allowedProviders = [
          'Playtech Live', 'Playtech Casino', 'Skywind Casino', 'RTG Slots',
          '7Mojos Casino', 'ICONIC21', 'Habanero'
        ];
        const voltProvide = ['Red Tiger Gaming', 'Betgames', 'Netgame', 'OnlyPlay', 'CQ9 Casino', 'Live88'];
        const endorphina = ['Qora', 'Ezugi', 'Gamizx', 'Triple PG', 'Evoplay'];
        const latst = ['ICONIC21', 'Live88', 'Spribe', 'Aviatrix'];
        const evoluton = ['Evolution Gaming'];

        const classifyAndSetBuckets = (gamesList) => {
          const jili = [], casino = [], ent = [], endor = [], latest = [], evolution = [];

          gamesList.forEach((game) => {
            const providerName = game?.provider?.name;
            if (!providerName) return;


            if (providerName === 'Jili') jili.push(game);
            if (allowedProviders.includes(providerName)) casino.push(game);
            if (voltProvide.includes(providerName)) ent.push(game);
            if (endorphina.includes(providerName)) endor.push(game);
            if (latst.includes(providerName)) latest.push(game);
            if (evoluton.includes(providerName)) evolution.push(game);
          });

          // Update UI buckets
          setJiliGames(jili);
          setCasino(casino);
          setEnt(ent);
          setEndorphina(endor);
          // setLatest(latest);
          setEvolution(evolution);

        };



        eventSource.addEventListener('message', (event) => {
          const data = JSON.parse(event.data);

          // Save token
          if (data.token) {
            setToken(data.token);
            localStorage.setItem('game_token', data.token);
          }

          // New chunk arrives
          if (data.chunk && Array.isArray(data.chunk)) {
            receivedGames = [...receivedGames, ...data.chunk];

            setGames([...receivedGames]); // All games for general view
            classifyAndSetBuckets(receivedGames); // Filter buckets updated live
          }

          // All chunks done
          if (data.complete) {
            eventSource.close();
            setGamesLoading(false);
            // Final classification (already done in chunk processing)
          }

          if (data.error) {
            // console.error("Backend error:", data.error);
            eventSource.close();
            setGamesLoading(false);
          }
        });

        eventSource.onerror = (error) => {
          // console.error("Connection error:", error);
          eventSource.close();
          setGamesLoading(false);
        };

        // A stream that opens and then goes quiet never fires complete or
        // error, so nothing above would ever clear the skeletons.
        gamesTimeout = setTimeout(() => setGamesLoading(false), 15000);

      } catch (err) {
        console.error('Error initializing game stream:', err);
        setGamesLoading(false);
      }
    };



    casinogames();
    return () => clearTimeout(gamesTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gamesAttempt]);

  const [gamesRetrying, setGamesRetrying] = useState(false);

  const retryGames = () => {
    setGames([]);
    setGamesLoading(true);
    setGamesAttempt((n) => n + 1);
    // The stream answers from localhost in about 40ms when it is going to
    // fail, so without a floor the button would flicker and the panel
    // would look like it had ignored the click. Held long enough to read.
    setGamesRetrying(true);
    setTimeout(() => setGamesRetrying(false), 700);
  };

  const handleActiveLink = (index) => {

    setActiveLink(index);

  };

  const scrollableList = [
    { name: "Cricket", imgLink: "/assets/images/cricket.svg" },
    // { name: "Football", imgLink: "/assets/images/football.webp" },
    // { name: "Tennis", imgLink: "/assets/images/Tennis New.svg" },
    // { name: "Horce Racing", imgLink: "/assets/images/Basketbaalls.svg" },
    // { name: "GreyHound Racing", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
  ];

  const scrollableList2 = [
    { name: "Football", imgLink: "/assets/images/football.webp" },
  ];
  const scrollableList3 = [
    { name: "Tennis", imgLink: "/assets/images/Tennis New.svg" },
  ];
  // const scrollableList4 = [
  //   { name: "Horce Racing", imgLink: "/assets/images/Basketbaalls.svg" },
  // ];
  // const scrollableList5 = [
  //   { name: "GreyHound Racing", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
  // ];


  /* Aviator card, promo strip and game tiles. Every way this could fail
     used to be silent: a guest's launch is refused with 401 by the player
     guard and the catch only logged it, and if the Aviator id had not
     loaded (provider list slow or down) the first line returned without
     a word. Each case now says something. */
  const openGameById = async (gameId) => {
    if (!isAuthenticated) {
      toast.error("Please log in to play.");
      setactive(true);
      return;
    }
    if (!gameId) {
      toast.error("This game is not available right now. Please try again in a moment.");
      return;
    }

    try {
      const response = await axios.post(
        base_url + "/api/gamelaunch/url",
        { gameId },
        { withCredentials: true }
      );

      if (response?.data?.success && response.data.url) {
        window.location.href = response.data.url;
      } else if (/login/i.test(response?.data?.message || "")) {
        toast.error("Please log in to play.");
        setactive(true);
      } else {
        toast.error(response?.data?.message || "Could not open the game. Please try again.");
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        toast.error("Please log in to play.");
        setactive(true);
      } else {
        toast.error("Could not open the game. Please try again.");
      }
    }
  };

  // The Aviator promo opens the Crash Games section, like the Aviator
  // quick-access card and Crash Games in the menu.
  const openAviator = () => navigate("/casinoGames", { state: { list: 11 } });

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);
  const isSmallScreen = window.innerWidth <= 768;

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 991);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const images = [
    "/assets/images/banner7.webp",
    "/assets/images/banner8.webp",
    "/assets/images/banner9.webp",
    "/assets/images/banner10.webp",
    "/assets/images/banner11.webp",
    "/assets/images/banner12.webp",
    "/assets/images/banner13.webp",
    // "/assets/images/banner14.webp",
    // "/assets/images/banner15.webp",
    // "/assets/images/banner9.webp",
  ];

  const images2 = [
    "assets/images/banner111.webp",
    "assets/images/banner222.webp",
    // "assets/images/banner333.webp",
  ];


  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    // Nine across made every tile 143px wide. Five on desktop and two on a
    // phone gives the artwork room to actually read.
    slidesToShow: isSmallScreen ? 2 : 5,
    slidesToScroll: 1, // Scroll 1 at a time
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
  };

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2, // Show 5 at a time (like your image)
    slidesToScroll: 1, // Scroll 1 at a time
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
  };

  // const styles = {
  //   marqueeDiv: {
  //     background: 'linear-gradient(rgb(103, 205, 246) 0%, rgb(51, 147, 186) 50%, rgb(0, 66, 92) 100%)',
  //     zIndex: 99,
  //     position: 'fixed',
  //     bottom: 0,
  //     width: '101%',
  //   }
  // };


  // Logged-in players used to be bounced to /home -- the old pre-redesign
  // page -- so the redesign and its fixes vanished the moment anyone logged
  // in. Everyone gets this page now; /home renders it too (index.js).

  // A second /api/valid/token stream used to open here on every home load
  // (#10). It re-downloaded the whole game catalogue that the stream above
  // already delivers, then sorted it into sixteen categories whose setters
  // were all commented out -- the work was thrown away.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);






  return (

    <>
      <LoginReg
        active={active}
        setactive={setactive}
        regactive={regactive}
        setregactive={setregactive}
      />
      <app-root _nghost-jrx-c101="" ng-version="12.2.16" >

        <div _ngcontent-jrx-c101="">
          <app-toasts
            _ngcontent-jrx-c101=""
            aria-live="polite"
            aria-atomic="true"
            className="ngb-toasts"
          ></app-toasts>
          <router-outlet _ngcontent-jrx-c101=""></router-outlet>
          <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
            <div _ngcontent-jrx-c95="" className="head-container">
              {/* {!isMobile && <TopBar />}
            {isMobile && <Header isSidebar2={isSidebar2} setSidebar={setSidebar} />} */}
              {/* {isLargeScreen && <TopBar />} */}

              {/* <div>
              <div className="row" style={styles.marqueeDiv}>
                <marquee>
                  <p className="mb-2" style={{ fontSize: "13px" }}>
                    Welcome back to Rajbet65. Let’s play
                  </p>
                </marquee>
              </div>
            </div> */}

              <Header isSidebar={isSidebar} setSidebar={setSidebar} />
              <div _ngcontent-jrx-c95="" className="body-container">
                {/* Was rendered only when isSmallScreen, so the header's menu
                    control toggled state on desktop with no panel to show.
                    Sidebar renders nothing while closed, so it is safe at any
                    width. */}
                <Sidebar
                  isSidebar={isSidebar}
                  setSidebar={setSidebar}
                  isDesktop={!isSmallScreen}
                />
                <div
                  _ngcontent-jrx-c95=""
                  className={`rightbar`}
                  style={{
                    paddingLeft: isLargeScreen ? "0px" : '0px',
                    paddingRight: isLargeScreen ? "3px" : '0px',
                    width: "100%",
                    transition: "width 0.3s ease-in-out",
                  }}
                >


                  {/* <Header isSidebar={isSidebar} setSidebar={setSidebar} /> */}
                  {/* <div className="news-bar">
      <marquee style={{ width: '100%' }}>
        <p className="m-0 w-100">
          👉IPL MONTH DHAMAKA OFFER..GET 3% REFILL BONUS ON EVERY DEPOSIT... USDT DEPOSIT OPTION IS ALSO AVAILABLE ON OUR SITE👈👈...TO CONFIRM DEPOSIT BRANCH NUMBER CONTACT HELPDESK NO +265899881378
        </p>
      </marquee>
    </div> */}
                  <div
                    _ngcontent-jrx-c95=""
                    className="sports-casino mt-15 d-none"
                  >
                    <ul _ngcontent-jrx-c95="" className="popular-tab">
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/sports/sportsbyid/4"
                        style={{
                          background:
                            "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Cricket
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/cricket.svg"
                          alt="Cricket_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/sports/sportsbyid/1"
                        style={{
                          background:
                            "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Football
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/football.webp"
                          alt="Football_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/sports/sportsbyid/2"
                        style={{
                          background:
                            "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Tennis
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/tennis.webp"
                          alt="Tennis_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/sports/sportsbyid/7522"
                        style={{
                          background:
                            "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Basketball
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/basketball.webp"
                          alt="Basketball_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/sports/raceschedule/7/ALL"
                        style={{
                          background:
                            "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Horse Racing
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/horse-racing.gif"
                          style={{ height: "35px" }}
                          alt="Horse-racing_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/sports/raceschedule/4339/ALL"
                        style={{
                          background:
                            "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Greyhound
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/Greyhound transparent.gif"
                          style={{ height: "35px" }}
                          alt="Greyhound_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/sports/sportsbyid/6"
                        style={{
                          background:
                            "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Boxing
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/horse-racing.gif"
                          style={{ height: "35px" }}
                          alt="Boxing_Kheloyaar360"
                        />
                      </li>
                    </ul>
                  </div>
                  <div _ngcontent-jrx-c95="" className="sports-casino d-none">
                    <ul _ngcontent-jrx-c95="" className="popular-tab">
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/casinos/games/LIVECASINO"
                        style={{
                          background:
                            "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Live Casino
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/live_casino.webp"
                          alt="Live Casino_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/casinos/games/ROULETTE"
                        style={{
                          background:
                            "linear-gradient(90deg, #20a635 2.29%, #22ff7a 83.94%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Casino Lobby
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/casino_lobby.webp"
                          alt="Casino Lobby_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        style={{
                          background:
                            "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                        }}
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Crazy Time
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/crazy_time.webp"
                          alt="Crazy Time_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/casinos/games/INSTANTWIN"
                        style={{
                          background:
                            "linear-gradient(270deg, #3984f7 0%, #242156 100%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Crash Games
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/crash_games.webp"
                          alt="Crash Games_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        style={{
                          background:
                            "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                        }}
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Virtual Sports
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/virtual_sports.webp"
                          alt="Virtual Sports_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        style={{
                          background:
                            "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                        }}
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Evolution
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/evolution.webp"
                          alt="Evolution_Kheloyaar360"
                        />
                      </li>
                      <li
                        _ngcontent-jrx-c95=""
                        routerlink="/casinos/games/TABLEGAME"
                        style={{
                          background:
                            "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                        }}
                        tabIndex="0"
                      >
                        <Link
                          _ngcontent-jrx-c95=""
                          className="type-heading typehead"
                        >
                          Table Games
                        </Link>
                        <img
                          _ngcontent-jrx-c95=""
                          src="/assets/images/table_games.webp"
                          alt="Table Games_Kheloyaar360"
                        />
                      </li>
                    </ul>
                  </div>
                  {/* <Banner /> */}

                  {/* <CategoryGrid></CategoryGrid> */}

     

                  {/* ---- HOME PAGE ORDER ---------------------------------
                      Hero -> quick access -> sports -> games -> casino
                      categories -> promotions.

                      It used to run: hero, three adverts, two video
                      banners, a games rail, a casino rail, and only then
                      the first match. Eleven blocks with no ranking, so
                      nothing on the page said what the site is for. The
                      product now comes before the advertising. */}
                  <app-upcoming
                    _ngcontent-jrx-c95=""
                    _nghost-jrx-c94=""
                    className="ng-star-inserted"
                  >
                    <div _ngcontent-jrx-c94="" className="upcoming-container">
                      {/* 1 -- HERO */}
                      <Carousel />

                      {/* 2 -- QUICK ACCESS
                          Was three unrelated promotional images. It is
                          product navigation now: a name, what it contains,
                          and a way in. */}
                      <section className="rb-section">
                        <div className="rb-section__head">
                          <h2 className="rb-section__title">Quick access</h2>
                        </div>
                        <div className="rb-quick">
                          {QUICK_ACCESS.map((q) => {
                            const live = q.countKey ? liveCounts[q.countKey] : 0;
                            return (
                              <button
                                type="button"
                                key={q.title}
                                className="rb-quick__card"
                                /* The sticker doubles as the background
                                   watermark, and the tint separates the
                                   six cards. Both are handed to CSS as
                                   custom properties. */
                                style={{
                                  "--rb-art": `url(${q.img})`,
                                  "--rb-tint": q.tint,
                                }}
                                onClick={() => {
                                  navigate(q.path, q.state ? { state: q.state } : undefined);
                                }}
                              >
                                <span className="rb-quick__icon" aria-hidden="true">
                                  <img src={q.img} alt="" loading="lazy" decoding="async" />
                                </span>
                                <span className="rb-quick__text">
                                  <span className="rb-quick__title">{q.title}</span>
                                  {live ? (
                                    <span className="rb-quick__live">{live} live now</span>
                                  ) : (
                                    <span className="rb-quick__sub">{q.sub}</span>
                                  )}
                                  <span className="rb-quick__cta">Explore &rarr;</span>
                                </span>
                              </button>
                            );
                          })}
                        </div>
                      </section>

                      {/* 3 -- SPORTS. The primary reason people are here, so
                          it sits directly under the fold rather than below
                          five rows of casino artwork. */}
                      <section className="rb-section">
                        <div className="rb-section__head">
                          <h2 className="rb-section__title">Sports</h2>
                          <button
                            type="button"
                            className="rb-section__link"
                            onClick={() => navigate("/sportall")}
                          >
                            View all sports &rarr;
                          </button>
                        </div>

                        {/* Sticky, so the sport you are looking at stays
                            switchable while you scroll a long list. */}
                        <div className="rb-sportbar">
                          <div className="sport-tabs" role="tablist" aria-label="Sports">
                            {SPORTS.map((sport, idx) => {
                              const isActive = idx === activeSportIdx;
                              const count = sportCounts[idx];
                              return (
                                <button
                                  key={sport}
                                  type="button"
                                  role="tab"
                                  aria-selected={isActive}
                                  onClick={() => setActiveSportIdx(idx)}
                                  className={
                                    isActive ? "sport-tab sport-tab--active" : "sport-tab"
                                  }
                                >
                                  <span className="sport-tab__label">{sport}</span>
                                  {count !== undefined && (
                                    <span className="sport-tab__count">{count}</span>
                                  )}
                                </button>
                              );
                            })}
                          </div>
                        </div>

                        <Inplay
                          data={activeSportIdx}
                          onCount={handleSportCount}
                          timeFilter={timeFilter}
                          setTimeFilter={setTimeFilter}
                          teamQuery={teamQuery}
                          setTeamQuery={setTeamQuery}
                        />
                      </section>

                      {/* 4 -- POPULAR GAMES
                          Real titles from the game feed rather than a rail of
                          untitled artwork, at one fixed aspect ratio so the
                          row does not reflow as images of different shapes
                          arrive. */}
                      <section className="rb-section">
                        <div className="rb-section__head">
                          <h2 className="rb-section__title">Popular games</h2>
                          <button
                            type="button"
                            className="rb-section__link"
                            onClick={() => navigate("/casinoGames", { state: { list: 0 } })}
                          >
                            View all &rarr;
                          </button>
                        </div>
                        <div className="rb-games">
                          {games && games.length > 0
                            ? games.slice(0, 10).map((game, i) => (
                                <button
                                  type="button"
                                  key={game?.id || i}
                                  className="rb-game"
                                  onClick={() => {
                                    if (isAuthenticated) openGameById(game?.id);
                                    else setactive(true);
                                  }}
                                >
                                  <span className="rb-game__art">
                                    <img
                                      src={game?.images?.[2]?.url || game?.images?.[0]?.url}
                                      alt={game?.name || "Casino game"}
                                      loading="lazy"
                                      decoding="async"
                                    />
                                    <span className="rb-game__play" aria-hidden="true">
                                      <i className="fa fa-play" /> Open
                                    </span>
                                  </span>
                                  <span className="rb-game__meta">
                                    <span style={{ minWidth: 0 }}>
                                      <span className="rb-game__name">
                                        {game?.name || "Game"}
                                      </span>
                                      <span className="rb-game__cat">
                                        {game?.provider?.name || game?.category || "Casino"}
                                      </span>
                                    </span>
                                    <span className="rb-game__arrow" aria-hidden="true">
                                      &rarr;
                                    </span>
                                  </span>
                                </button>
                              ))
                            : gamesLoading
                            ? Array.from({ length: 10 }).map((_, i) => (
                                <div
                                  key={"gskel" + i}
                                  className="rb-skeleton"
                                  style={{ aspectRatio: "16 / 13" }}
                                  aria-hidden="true"
                                />
                              ))
                            : null}
                        </div>
                        {!gamesLoading && (!games || games.length === 0) && (
                          <UnavailablePanel
                            title="Casino games aren't loading"
                            body="Our games come from an outside provider, and we can't reach them at the moment. Sports betting is running normally."
                            onRetry={retryGames}
                            retrying={gamesRetrying}
                            secondaryLabel="Go to sports"
                            onSecondary={() => navigate("/sportall")}
                            note="Nothing is wrong with your account or your balance."
                          />
                        )}
                      </section>

                      {/* 5 -- CASINO CATEGORIES */}
                      <section className="rb-section casino-tiles-section">
                        <div className="rb-section__head">
                          <h2 className="rb-section__title">Casino</h2>
                          <button
                            type="button"
                            className="rb-section__link"
                            onClick={() => navigate("/casinoGames", { state: { list: 0 } })}
                          >
                            View all &rarr;
                          </button>
                        </div>
                        <div className="casino-tiles">
                          {CASINO_TILES.map((tile) => (
                            <Link
                              key={tile.label}
                              to="/casinoGames"
                              state={{ list: tile.list }}
                              className="casino-tile"
                            >
                              <img
                                src={tile.img}
                                alt={tile.label}
                                loading="lazy"
                                decoding="async"
                              />
                              <span className="casino-tile__label">{tile.label}</span>
                            </Link>
                          ))}
                        </div>
                      </section>

                      {/* 6 -- PROMOTIONS
                          Last, not first. The artwork can be as loud as it
                          likes; the container around it is one radius, one
                          border and one aspect ratio, so five creatives from
                          five designers still read as one page. */}
                      <section className="rb-section">
                        <div className="rb-section__head">
                          <h2 className="rb-section__title">Promotions</h2>
                        </div>
                        <PromoStrip onOpenAviator={openAviator} />
                      </section>
                    </div>
                  </app-upcoming>

                  {list === 0 && <AllCasino games={games} searchText={searchText} token={token} />}


                  {/* latest games */}
                  {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/titleImg.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Latest Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        href="/casinos/games/POPULAR"
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div>
                  </div>
                  <SliderContainer CurrentSlider={{token, games:latest}}/>
                </div> */}

                  {/* hot games */}
                  {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/hots.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Hot Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="/casinos/games/POPULAR"

                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div>
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: ent }} />
                </div> */}


                  {/* new release */}
                  {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/NewReleases.png"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">New Releases</span>
                    </div>
                     <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: endorphina }} />
                </div> */}


                  {/* jili games */}
                  {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/jili.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Jili (Indian Casino)</span>
                    </div>
                     <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: jiliGames }} />
                </div> */}

                  {/* evolution */}
                  {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/evo.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Evolution (Intl Casino)</span>
                    </div>
                     <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: evolution }} />
                </div> */}


                  {/* casino games */}
                  {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/Casino.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Casino Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> 
                  </div>
                  <SliderContainer CurrentSlider={{ token, games: casino }} />
                </div> */}

                  {/* < ScrollableContent /> */}
                  {/* 
                <div className="px-1">
                  <Racing />
                </div> */}

                  {/* Trust strip. The page used to end with nine provider
                      logos and one 11px sentence of small print; the things
                      a gambling product should be explicit about were the
                      least visible things on it. */}
                  <div className="rb-shell">
                    <div className="rb-trust">
                      <a className="rb-trust__card" href="/responsible-gaming"
                         onClick={(e) => { e.preventDefault(); navigate("/responsible-gaming"); }}>
                        <span className="rb-trust__icon" aria-hidden="true">
                          <i className="fa fa-shield-halved" />
                        </span>
                        <span>
                          <span className="rb-trust__title">Responsible gambling</span>
                          <span className="rb-trust__body">
                            Deposit limits, taking a break, and self-exclusion.
                            18+ only.
                          </span>
                        </span>
                      </a>
                      <a className="rb-trust__card" href="/contact-us"
                         onClick={(e) => { e.preventDefault(); navigate("/contact-us"); }}>
                        <span className="rb-trust__icon" aria-hidden="true">
                          <i className="fa fa-headphones" />
                        </span>
                        <span>
                          <span className="rb-trust__title">24/7 support</span>
                          <span className="rb-trust__body">
                            Questions about a bet, a deposit or your account.
                          </span>
                        </span>
                      </a>
                      <a className="rb-trust__card" href="/rules"
                         onClick={(e) => { e.preventDefault(); navigate("/rules"); }}>
                        <span className="rb-trust__icon" aria-hidden="true">
                          <i className="fa fa-scale-balanced" />
                        </span>
                        <span>
                          <span className="rb-trust__title">Rules and terms</span>
                          <span className="rb-trust__body">
                            How markets settle, and what happens when an event
                            is voided.
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>

                  <RbFooter />



                  {/* Rendered at every width; the CSS hides it from 992px.
                      The old width check ran once at render, so rotating a
                      phone or resizing a window left the bar behind. */}
                  <MarqueeBottom onMenuClick={() => setSidebar(true)} />
                </div>
              <WhatsAppButton/>
              </div>
            </div>
          </app-landing-page-new>


          <div className="slider-container"></div>
        </div>
      </app-root>

    </>
  );
};

// here new code add

const AllCasino = ({ games, searchText, token }) => {
  const [active, setActive] = useState(false);
  const [filteredGames, setFilteredGames] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const searchTimeoutRef = useRef(null);
  const { isAuthenticated } = useContext(AuthContext);
  const [displayCount, setDisplayCount] = useState(28);
  const [visibleGames, setVisibleGames] = useState([]);


  useEffect(() => {
    setFilteredGames(games || []);
  }, [games]);
  useEffect(() => {
    setVisibleGames(filteredGames.slice(0, displayCount));
  }, [filteredGames, displayCount]);


  useEffect(() => {

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!searchText) {
      setFilteredGames(games || []);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);

    searchTimeoutRef.current = setTimeout(() => {
      const lowerCaseSearch = searchText.toLowerCase();

      const filtered = games.filter(game => {

        if (!game) return false;
        if (game.name?.toLowerCase().includes(lowerCaseSearch)) return true;
        if (game.provider?.name?.toLowerCase().includes(lowerCaseSearch)) return true;
        return false;
      });
      setDisplayCount(28);
      setFilteredGames(filtered);
      setIsSearching(false);
    }, 300);


    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, [games, searchText]);
  const loadMoreGames = () => {
    setDisplayCount(prev => prev + 28);
  };

  /* Same treatment as the openGameById further up this file: tell the player
     which of the three things went wrong instead of one catch-all message, and
     never navigate to an absent url. */
  const openGameById = async (gameId) => {
    if (!gameId) {
      toast.error('This game is not available right now. Please try again in a moment.');
      return;
    }
    try {
      const response = await axios.post(base_url + '/api/gamelaunch/url',
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            'content-type': 'application/json',
          }
        }
      );

      if (response?.data?.success && response.data.url) {
        window.location.href = response.data.url;
      } else if (/login/i.test(response?.data?.message || '')) {
        toast.error('Please Login to play!');
        setActive(true);
      } else {
        toast.error(response?.data?.message || 'Could not open the game. Please try again.');
      }
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401 || status === 403) {
        toast.error('Please Login to play!');
        setActive(true);
      } else {
        toast.error(
          err?.response?.data?.message || 'Could not open the game. Please try again.'
        );
      }
    }
  };

  const gameCards = useMemo(() => {
    // return filteredGames?.map((game, index) => (
    return visibleGames?.map((game, index) => (
      <button
        type="button"
        key={game?.id || index}
        className="rb-game"
        onClick={() => { if (isAuthenticated) openGameById(game?.id); else setActive(true); }}
      >
        <span className="rb-game__art">
          <img
            src={game?.images?.[2]?.url || game?.images?.[0]?.url}
            alt={game?.name || 'Casino game'}
            loading="lazy"
            decoding="async"
          />
          <span className="rb-game__play" aria-hidden="true">
            <i className="fa fa-play" /> {isAuthenticated ? 'Open' : 'Log in'}
          </span>
        </span>
        <span className="rb-game__meta">
          <span style={{ minWidth: 0 }}>
            <span className="rb-game__name">{game?.name || 'Game'}</span>
            <span className="rb-game__cat">
              {game?.provider?.name || game?.category || 'Casino'}
            </span>
          </span>
          <span className="rb-game__arrow" aria-hidden="true">&rarr;</span>
        </span>
      </button>
    ));
  }, [filteredGames, isAuthenticated]);
  return (
    <>

   
      <div className="upcoming-container">
        {isSearching && (
          <div className="text-center my-2">
            <span className="text-white">Searching...</span>
          </div>
        )}

        {!isSearching && filteredGames.length === 0 && searchText && (
          <div className="text-center my-4">
            <p className="text-white">No games found matching "{searchText}"</p>
          </div>
        )}

        {/* Was a full-width solid blue bar containing the word "Casino"
            -- a heading painted as if it were a control. It is the same
            section header the rest of the page uses now. */}
        <div className="rb-section__head" style={{ marginTop: "var(--rb-5)" }}>
          <h2 className="rb-section__title">All casino games</h2>
        </div>

        <div className="rb-games">
          {gameCards}
        </div>
        {visibleGames.length < filteredGames.length && (
          <div className="text-center my-3">
            <button
              type="button"
              onClick={loadMoreGames}
              className="rb-btn rb-btn--secondary"
            >
              Load more games
            </button>
          </div>
        )}
      </div>
    </>
  );
};